export default __webpack_public_path__ + "static/sorting-colors-in-js-d8db6e43703f4787add383de74d1a722.svg";